module.exports = __webpack_public_path__ + "static/assets/material-symbols-light_finance.svg";